import React from 'react';
import { stats } from '../../data/content';
export function StatsBar() {
  return <section aria-label="Risultati chiave" className="w-full bg-plum-deep" data-id="element-296" data-mp="1j8ma64pvky1q">
      <div className="mx-auto w-full max-w-content px-5 py-8 sm:px-8 sm:py-10" data-id="element-297" data-mp="1j6jasu2u1skc">
        <dl className="grid grid-cols-2 gap-x-4 gap-y-7 lg:grid-cols-4" data-id="element-298" data-mp="1o6nvkwarx9gd">
          {stats.map(stat => <div key={stat.label} className="text-center" data-id="element-299" data-mp="1t0s3pivrznj1">
              <dt className="sr-only" data-id="element-300" data-mp="1wz90b8hklfm7">{stat.label}</dt>
              <dd data-id="element-301" data-mp="21zdgexekg8bw">
                <span className="block font-display text-3xl font-black leading-none text-white sm:text-4xl lg:text-5xl" data-id="element-302" data-mp="21yu9ebqgf4cn">
                  {stat.value}
                </span>
                <span className="mt-2 block text-[11px] font-bold uppercase leading-snug tracking-[0.12em] text-white/60 sm:text-xs" data-id="element-303" data-mp="26wlxeunza6bk">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}